import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, signal } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { BusinessBankingService } from "src/app/services/business-banking.service"
import { IbanValidator } from "src/app/tools/iban.validator"

@Component({
  selector: "ow-business-banking-form",
  templateUrl: "./business-banking-form.component.html"
})
export class BusinessBankingFormComponent implements OnDestroy, OnInit {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly businessBankingService = inject(BusinessBankingService)

  public readonly form = new FormGroup({
    accountOwner: new FormControl<string>(this.businessBankingService.getBusinessBanking().accountOwner),
    iban: new FormControl<string>(this.businessBankingService.getBusinessBanking().iban, [
      Validators.required,
      IbanValidator
    ]),
    bic: new FormControl<string>(this.businessBankingService.getBusinessBanking().bic, [Validators.required, Validators.pattern(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/)]),
    creditInstitution: new FormControl<string>(this.businessBankingService.getBusinessBanking().creditInstitution, [Validators.required, Validators.maxLength(50)]),
    authorize: new FormControl<boolean>(this.businessBankingService.getBusinessBanking().authorize, [Validators.requiredTrue])
  })

  private readonly subscriptions = [
    this.form.controls.accountOwner.valueChanges.subscribe((value) => {
      if (this.form.controls.accountOwner.valid) {
        this.businessBankingService.setBusinessBanking({ accountOwner: value! })
      }
    }),
    this.form.controls.iban.valueChanges.subscribe((value) => {
      if (this.form.controls.iban.valid) {
        this.businessBankingService.setBusinessBanking({ iban: value! })
      }
    }),
    this.form.controls.bic.valueChanges.subscribe((value) => {
      if (this.form.controls.bic.valid) {
        this.businessBankingService.setBusinessBanking({ bic: value! })
      }
    }),
    this.form.controls.creditInstitution.valueChanges.subscribe((value) => {
      if (this.form.controls.creditInstitution.valid) {
        this.businessBankingService.setBusinessBanking({ creditInstitution: value! })
      }
    }),
    this.form.controls.authorize.valueChanges.subscribe((value) => {
      if (this.form.controls.authorize.valid) {
        this.businessBankingService.setBusinessBanking({ authorize: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

}
